import './normalize.css';
import './index.sass';
import 'rxjs';
import '@rossum/ui/theme/fonts';
import { setupWorker } from 'msw/browser';
import { isIE } from 'react-device-detect';
import { createRoot } from 'react-dom/client';
import { LicenseInfo } from '@rossum/ui/x-license';
import { muiXLicenseKey } from './constants/config';
import App from './containers/App';
import { handlersMap } from './mocks/browser';
import onLoadScript from './onLoadScripts';
import store from './redux/configureStore';

const enableMocking = () => {
  if (!localStorage.getItem('mock_server_enabled')) {
    return Promise.resolve();
  }

  const mockServerScenario = localStorage.getItem('mock_server_scenario') ?? '';

  const mockServerHandlers = handlersMap[mockServerScenario];

  if (!mockServerHandlers) {
    return Promise.resolve();
  }

  const worker = setupWorker(...mockServerHandlers);

  return worker.start();
};

LicenseInfo.setLicenseKey(muiXLicenseKey);

if (!isIE) {
  enableMocking().then(() => {
    onLoadScript(store);
    const root = createRoot(document.getElementById('root'));
    root.render(<App />);
  });
}
